import React, { useState, useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import axios from "axios";
import Review from "../components/Review";

const ReviewPage = () => {
  const { bookingId } = useParams();
  const [providerName, setProviderName] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!bookingId) {
      setLoading(false);
      return;
    }

    const fetchBookingInfo = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/bookings/${bookingId}/for-review`
        );
        setProviderName(response.data.providerName);
      } catch (err) {
        console.error("Error fetching booking info:", err);
        setError(err.response?.data?.message || "Failed to load booking information");
      } finally {
        setLoading(false);
      }
    };

    fetchBookingInfo();
  }, [bookingId]);

  // If there's no bookingId in the URL, redirect home
  if (!bookingId) {
    return <Navigate to="/" replace />;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg p-8 text-center">
          <p className="text-red-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-center mb-6">
          Leave a Review for {providerName || "Provider"}
        </h1>
        <Review bookingId={bookingId} />
      </div>
    </div>
  );
};

export default ReviewPage;
